import TEMPLATE_URL from "emun.auth/users/user-picker.htm";
import controller from "emun.auth/users/user-picker.controller";
import open from "webmodals/open";

const NOOP = () => { };

export default ({
	size = "lg",
	backdrop = "static",
	templateUrl = TEMPLATE_URL,
	placement = undefined, // "right",
	title = "Select Users(s)...",
	subTitle = "",
	view = "table",
	single = false,
	viewSelections = false,
	okButtonText = "OK",
	closeButtonText = single ? "Close" : "Cancel",
	selected = {},
	criteria = {},
	onToggle = NOOP,
	onUserSelected = NOOP,
	onUserDeselected = NOOP
} = {}) =>
	open({
		size,
		backdrop,
		templateUrl,
		console: console.debug(templateUrl, {
			placement,
			size,
			backdrop,
			title,
			view
		}),
		placement,
		controller,
		bindToController: true,
		controllerAs: "$ctrl",
		resolve: {
			options: () => ({
				title,
				subTitle,
				onUserSelected,
				onUserDeselected,
				onToggle,
				criteria,
				view,
				viewSelections,
				okButtonText,
				closeButtonText,
				single,
				selected
			})
		}
	}).result;
